import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useLocation } from "react-router-dom";

export default function ModalViewDetails(props) {
  const { isOpen, toggle, email } = props;
  const location = useLocation();

  return (
    <>
      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Visualizar Detalhes</ModalHeader>
        <ModalBody>
          <h4 style={{ textAlign: "center", marginBottom: 20 }}>
            {location.state.event.title}
          </h4>
          <div
            id="div-set-details"
            dangerouslySetInnerHTML={{
              __html: email.current.getDetails() || "",
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
}
